export enum FilterField {
  ADD = 'add',
  ADD_PART = 'add_part',
  ADVANCED = 'advanced',
  AUTOCOMPLETE = 'autocomplete',
  CHECKBOX_GROUP = 'checkbox_group',
  DATE = 'date',
  DATE_RANGE = 'date_range',
  IMPORT = 'import',
  INPUT_GROUP = 'input_group',
  RANGE = 'range',
  SELECT = 'select',
  SEARCH = 'search',
  TEXTFIELD = 'textfield',
}

export enum InputType {
  ASYNC_SELECT = 'asyncSelect',
  CHECKBOX = 'checkbox',
  DATE_INPUT = 'dateInput',
  SELECT = 'select',
  TEXTFIELD = 'textfield',
  TOGGLE_SWITCH = 'toggleSwitch',
  TEXTEDITOR = 'texteditor',
  PASSWORD = 'password',
}

export enum SelectionOptions {
  ALL = 'select all',
  DISPLAYED = 'displayed',
  FILTERED = 'filtered',
  NONE = 'none',
}
